/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, IconsPlugin, ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueMeta from 'vue-meta'
import 'vue-select/dist/vue-select.css'

import router from './router'
import store from './store'
import App from './App.vue'
// import VueHtml2pdf from 'vue-html2pdf';

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { setHttpContext  }from './util/HttpContext'

// Import VeeValidate et les messages de localisation français
import { configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import fr from '@vee-validate/i18n/dist/locale/fr.json'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
//import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@fortawesome/fontawesome-free/css/all.css'
import VueSignaturePad from 'vue-signature-pad';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueSignaturePad)
// Vue.component('vue-html2pdf', VueHtml2pdf);

// Composition API
Vue.use(VueCompositionAPI)
setHttpContext(store, router)

// Vue Meta
Vue.use(VueMeta, {
    keyName: 'head'
})
// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// Configure VeeValidate with French language
configure({
    generateMessage: localize({ fr }), // Définit les messages en français
})
localize('fr'); // Définit le français comme langue par défaut

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
